import React, { ReactNode } from "react";
import FaqHelpFab from "../faq/FaqHelpFab";
import { authPageInnerClass, authPageShellClass } from "../../styles/authUi";

interface AuthPageLayoutProps {
  children: ReactNode;
}

/**
 * Centered auth page shell using COLOR_SCHEME surface backgrounds.
 */
export const AuthPageLayout: React.FC<AuthPageLayoutProps> = ({ children }) => {
  return (
    <div className={authPageShellClass}>
      <div className={authPageInnerClass}>{children}</div>
      <FaqHelpFab variant="public" />
    </div>
  );
};

export default AuthPageLayout;
